import { useQuery } from '@tanstack/react-query';

import { contactsAPI, contactsEndpoints } from '@/api/contacts';

export const useContactActivities = (contactId?: string) => {
  const queryKey = [contactsEndpoints.activities(contactId ?? '')];

  const { data, status, error } = useQuery({
    queryKey,
    queryFn: () => contactsAPI.listActivities(contactId!),
    enabled: !!contactId,
  });

  const activities = data?.activities ?? [];

  return { activities, status, error };
};
